import moment from 'moment-timezone';
import DatePicker from 'vue2-datepicker';
import custom from '@/f1/custom';
import codes from '@/f1/codes';
// import 'vue2-datepicker/index.css';
import { api } from '@/f1/service';
import { Switch as cSwitch } from '@coreui/vue';
import Language from './language';

//restful api
// import { wmds_v2 as ws } from '@/f1/service/api'

//i18n_data
import _i18n_data from './i18n_data'
import i18n_data from '@/component/i18n_data';

// const _i18n_data = {
//   saved: {
//     EN : `saved`,
//     KO : `저장되었습니다`,
//     JP : `saved`,
//   },
//   updated: {
//     EN : `updated`,
//     KO : `업데이트되었습니다`,
//     JP : `updated`,
//   },
// };

export default {
  components : { DatePicker, cSwitch, Language },
  name : "siteList",
  props: ['policy_id', "view_detail", "enable_new"],
  watch: {
    policy_id() {
      console.log("watch updated props data", this.policy_id)
      this.$refs._list.refresh();
    }
  },
  data: () => ({
    custom,
    so : Object.assign({}, codes.DEFAULT_OPT, { opt : {} }),
    limit : 15,
    sites : [],
    toggle_confirm : false,
    toggle_index : -1,
    change_to_disable : [],
    change_to_enable : [],
    loading : false,
  }),
  computed: {
    // i18n_data() { return _i18n_data; }, // i18n 메세지 변환용.
    fields : function() {
      return _i18n_data.i18n_fields[this.i18n]
    },
    startRow : function() { return this.so.totalRows - (this.so.currentPage - 1) * this.so.perPage; },
    rowCount: function() { return this.so.totalRows || 0; }
  },
  methods: {
    status_toggle_modal(index, is_alive) {
      // 처음에 초기화 하는 함수
      if(this.loading) { return console.log('loading') }
      // console.log('this.toggle_confirm', this.toggle_confirm, index, is_alive,)
      if(index == -1) { this.sites[this.toggle_index].is_alive = !this.sites[this.toggle_index].is_alive; this.toggle_confirm = false; return }
      // else {
      //   this.toggle_confirm = true;
      // }
      else if(is_alive == false && this.change_to_disable.indexOf(index) > -1) { this.toggle_confirm = true; }
      else if(is_alive == true && this.change_to_enable.indexOf(index) > -1) { this.toggle_confirm = true; }
    },
    status_toggle_api() {
      let model = this.sites[this.toggle_index]
      if(model.is_alive) {
        let index = this.change_to_enable.indexOf(this.toggle_index)
        if(index > -1) {
          this.change_to_enable.splice(index, 1)
          this.change_to_enable.push(index)
        }
      } else {
        let index = this.change_to_disable.indexOf(this.toggle_index)
        console.log("toggle to remove", index)
        if(index > -1) {
          this.change_to_disable.splice(index, 1)
          this.change_to_enable.push(index)
        }
      }

      return api.wmds.WMDS_Call('site', 'update', Object.assign({}, { id : model.id, is_alive : model.is_alive }))
      // return ws.site.update(Object.assign({}, { id : model.id, is_alive : model.is_alive }))
        .then(() => {  this.toggle_confirm = false; this.refresh(); this.$toastr.s(`${i18n_data._i18n_success.saved[this.i18n]}`) })
        .catch(e => this.$toastr.e(e.data ? `${i18n_data._i18n_error.update_failed[this.i18n]}` :  e.data.message || e.data.title ? e.data.title : e.statusText))
    },
    search_opt() {
      this.so.adv = !this.so.adv;
      if(this.so.adv) {
        this.so.opt['created_at_ed'] = moment().add(1, "day");
        this.so.opt['last_visit_ed'] = moment().add(1, "day");
        this.so.opt['is_alive'] = true;
        this.so.opt['match_type'] = 'and';
        this.so.sv = ''
      } else { this.reset(); }
    },
    set_op(k, v) {
      if(v === false || v === true) { return { name : k, value : v === false ? false : true, op : '=' } }
      return { name : k, value : `%${v}%`, op : 'like' }
    },
    set_sd(v, k = 'created_at') {
      let opt = this.so.opt;

      if(!v) { delete opt[`${k}_sd`]; delete opt[`${k}_ed`]; }
      else {
        let ed = opt[`${k}_ed`] || moment().startOf('d');
        let sd = opt[`${k}_sd`] || ed;
        switch(v) {
          // case '+1d' : sd = moment(sd).subtract(-1, 'd'); break;
          case '-1d' : sd = moment(sd).subtract(1, 'd'); break;
          case '-1w' : sd = moment(sd).subtract(1, 'w'); break;
          case '-1m' : sd = moment(sd).subtract(1, 'M'); break;
          case 'w' : sd = moment(ed).startOf('isoweek'); break;
          case 'm' : sd = moment(ed).startOf('month'); break;
        }
        opt[`${k}_sd`] = sd.format('YYYY-MM-DD');
      }
      this.so.opt = Object.assign({}, this.so.opt, opt);
    },
    // TODO : 테스트 용도임, 배포하면 안됨
    async deleteAll() {
      let rs = await api.wmds.WMDS({ target : 'site', cmd : 'clean' })
      //let rs = await ws.site.clear()
      console.log(rs)
      this.refresh()
    },
    async check_policy() {
      if(this.sites.length < 1) { this.$parent.$emit('count', 0); return this.$router.push({ name: 'wmds_site', params: { id : 'add' } }) }

      let rs = await api.wmds.WMDS({ target : 'policy', cmd : 'list' })
      //let rs = await ws.policy.list()
      if(rs.error) { return this.$toastr.e('policy load failed') }
      if(rs.total == 0 ){ this.$toastr.w(`${_i18n_data._i18n_warning.policy_check[this.i18n]}`); this.$router.push({ name : 'wmds_policy', params : { id : 'add' } }) }
      else{ this.$router.push({ name: 'wmds_site', params: { id : 'add' } }) }
    },
    reset() { this.so = Object.assign({}, codes.DEFAULT_OPT, { opt : {} }); this.refresh(); },
    refresh() { this.$refs._list.refresh(); },
    getItems: function(ctx) { return this.load(ctx); },
    load(ctx = {}) {
      if(this.loading) {
        return this.loading = false
      }
      this.loading = true
      let so = {
        target : 'site', cmd : 'list',
        body : {
          sort : [{ name : "id", op : "desc" }],
          or : [],
          and : []
        },
        offset : (this.so.currentPage-1 || 0) * Number(this.so.perPage), limit: Number(this.so.perPage), // 10 은 나중에 변수 처리해야함.
      }

      if(ctx.sortBy) { so.body.sort = [ { name : ctx.sortBy, op : !ctx.sortDesc && 'desc' } ]; }
      if(this.policy_id) { so.body.and.push({ name : 'policy_id', value : this.policy_id, op : '='}) }
      if(this.so.sv && this.so.sk) { so.body.and.push(this.set_op(this.so.sk, this.so.sv, so)); }

      if(this.so.adv && this.so.opt) {
        var k = Object.keys(this.so.opt)
        for (let i = 0; i < k.length; i++) {
          if(k[i] == 'match_type') { continue; }
          let cond = undefined;

          switch (k[i]) {
            case 'created_at_sd':
              if(!this.so.opt[k[i]]) { this.$toastr.w(`${i18n_data._i18n_warning.require_startTime[this.i18n]}`, `${i18n_data._i18n_warning.notice[this.i18n]}`); break; }
              cond = { name : k[i].slice(0, 10), value : moment(this.so.opt[k[i]]).format("YYYY-MM-DD"), op : ">=" }
              break;
            case 'created_at_ed':
              if(!this.so.opt[k[i]]) { this.$toastr.w(`${i18n_data._i18n_warning.require_endTime[this.i18n]}`, `${i18n_data._i18n_warning.notice[this.i18n]}`); break; }
              cond = { name : k[i].slice(0, 10), value : moment(this.so.opt[k[i]]).format("YYYY-MM-DD"), op : "<" }
              break;
            case 'last_visit_sd':
              if(!this.so.opt[k[i]]) { this.$toastr.w(`${i18n_data._i18n_warning.require_startTime[this.i18n]}`, `${i18n_data._i18n_warning.notice[this.i18n]}`); break; }
              cond = { name : k[i].slice(0, 10), value : moment(this.so.opt[k[i]]).format("YYYY-MM-DD"), op : ">=" }
              break;
            case 'last_visit_ed':
              if(!this.so.opt[k[i]]) { this.$toastr.w(`${i18n_data._i18n_warning.require_endTime[this.i18n]}`, `${i18n_data._i18n_warning.notice[this.i18n]}`); break; }
              cond = { name : k[i].slice(0, 10), value : moment(this.so.opt[k[i]]).format("YYYY-MM-DD"), op : "<" }
              break;
            default:
              cond = this.set_op(k[i], this.so.opt[k[i]]);
              break;
          }
          if(cond.value == '%%' || cond.value === '') { continue; }
          if(this.so.opt['match_type'] == "and") { so.body.and.push(cond) }
          else { so.body.or.push(cond) }
        }
      }
      return api.wmds.WMDS(so)
      //Todo : 확인 완료
      // return ws.site.list(so)
        .then(rs => {
          this.so.totalRows = rs.total;
          this.sites = rs.body ? rs.body : [];
          this.change_to_disable = []; this.change_to_enable = [];

          console.log('reload')

          this.sites.forEach((s, index) => {
            try {
              s.is_alive && this.change_to_disable.indexOf(index) < 1 ?  this.change_to_disable.push(index) : ''
              !s.is_alive && this.change_to_enable.indexOf(index) < 1 ?  this.change_to_enable.push(index) : ''
            } catch (e) { console.error(e) }
          })
          this.$parent.$emit('count', this.sites.length)
          this.loading = false

          return this.sites;
        }).catch(e => {
          this.$toastr.e(e.data ? `${i18n_data._i18n_error.load_failed[this.i18n]}` :  e.data.message || e.data.title ? e.data.title : e.statusText)
        })
    },
    detail: function(site_id) { this.policy_id ? this.$router.push({ name : 'wmds_site', params : { id : site_id } })  : this.$router.push(`site/${site_id}`) },
    upload: function() { this.$router.push({ name : 'wmds_site', params : { id : 'csv' } }) },
    hideList: function(e) {
      this.show = !e; console.log('site.list.vue', 'got event (list show/hide)', !e ? 'show' : 'hide')
    }
  },
  created: function() {   console.log('site.list.vue', 'created'); },
  destroyed: function() { console.log('site.list.vue', 'destroyed'); },
  mounted: function() { console.log('site.list.vue', 'mounted'); },
}
